export enum RuleNotificationInterval {
  Hourly = 0,
  Daily = 1
}